import React from 'react'
import './Info.css'

const Info = () => {
  return (
    <div className="info-container">
      <div className="info">
        <h1>Gracias por visitar mi portfolio y tomarte la molestia de llegar hasta el final, espero que te haya gustado!</h1>
      </div>
    </div>
  )
}

export default Info
